import { LegalPage } from './LegalPage';
import Terms, { frontmatter as fm } from '../../content/terms.mdx';

export function TermsPage() {
  return (
    <LegalPage
      title="Terms of use · Brian Ellison Design"
      description="The terms under which this site is provided."
      canonical="https://brianellisondesign.com/terms"
      Body={Terms}
      headline={(fm['headline'] as string) ?? 'Terms of use.'}
    />
  );
}
